

















































































import Vue from "vue"
import { ROUTES } from "@/constants"
import { Component } from "vue-property-decorator"
import { emitAlert } from "@/helpers/alert.helper"
import { EVENTS } from "@/constants"
import { TestSession, User } from "@/generated/graphql"
import { getConfigMap } from "@/helpers/config.helper"

@Component
export default class EndSessionButton extends Vue {
  show = false
  showCertification = false
  loading = false
  certifiedSession: boolean | null = null
  certificationComments = ""

  get testSession(): TestSession {
    return this.$store.getters["livestream/testSession"]
  }

  get currentUser(): User {
    return this.$store.getters["currentUser/currentUser"]
  }

  get streamOwner(): User {
    const a = this.$store.getters["livestream/streamOwner"]
    return a
  }

  get disableBtn(): string {
    return this.$store.getters["livestream/disableBtnDotUi"]
  }

  get displayButton(): boolean | undefined | null {
    const ownerId = this.streamOwner ? this.streamOwner.id : null
    return this.testSession && this.testSession.active && ownerId == this.currentUser.id
  }

  get isEndSessionPopupEnabled(): boolean {
    // @ts-ignore
    const config = getConfigMap(this.$auth?.userConfig || [])
    return config["endSessionPopup_cat_ui"]?.enabled || false
  }

  showDialog(show: boolean) {
    this.show = show
  }

  showErrorFlash(message: string): void {
    emitAlert(EVENTS.GLOBAL_ERROR, message)
    this.showDialog(false)
    this.$router.push({ name: ROUTES.DASHBOARD.name })
  }

  onConfirmEnd(): void {
    if (!this.streamOwner) {
      this.showErrorFlash("You cannot end a session that's not claimed")
      return
    }
    if (this.streamOwner.id != this.currentUser.id) {
      this.showErrorFlash("You cannot end a session that's not yours")
      return
    }
    if (this.testSession.initiator == "dot_ui") {
      this.showErrorFlash("You must end via the dot ui")
      return
    }

    this.show = false
    
    // Only show certification popup if feature flag is enabled
    if (this.isEndSessionPopupEnabled) {
      this.showCertification = true
    } else {
      // Skip certification and end session directly
      this.endSession()
    }
  }

  cancelCertification(): void {
    this.showCertification = false
    this.certifiedSession = null
    this.certificationComments = ""
  }

  endSession(): void {
    this.loading = true
    this.$store
      .dispatch("livestream/actions", {
        catId: this.testSession.catId,
        typeOfAction: "end_session",
        certifiedSession: this.isEndSessionPopupEnabled ? this.certifiedSession : null,
        certificationComments: this.isEndSessionPopupEnabled && this.certifiedSession === false ? this.certificationComments : null,
      })
      .then(res => {
        if (res.status !== "error") {
          emitAlert(EVENTS.GLOBAL_SUCCESS, "Successfully ended test session")
          this.$router.push({ name: ROUTES.DASHBOARD.name })
        }
      })
      .catch(() => emitAlert(EVENTS.GLOBAL_ERROR, "Error ending test session"))
      .finally(() => {
        this.loading = false
        this.showCertification = false
        this.certifiedSession = null
        this.certificationComments = ""
      })

    this.$gtag.event("end", {
      event_category: "test_session",
      event_label: "End Test Session Click",
      value: this.testSession.catId,
    })
  }
}
